import { useQuery } from 'react-query'

import { getCompanyByAlphaId } from '@/api/agency/get-company-by-alpha-id'

export const useGetCompanyByAlphaId = (alphaId: string) => {
  return useQuery({
    queryFn: () => getCompanyByAlphaId({ alphaId }),
    queryKey: ['companyByAlphaId', alphaId],
    refetchOnWindowFocus: false,
  })
}
